import React, { useState, useEffect } from "react";
import areObjectsEqual from "../../../../utils/areObjectsEqual";

/**
 * Form Component
 * Form for managing distribution colors
 */
const Form = ({ formData, handleSubmit }) => {
  const [form, setForm] = useState(formData);
  const [copyData, setCopyData] = useState();
  const [errors, setErrors] = useState({
    sponsor_color: false,
    beneficiary_color: false,
    artist_color: false,
  });
  const hasUnsavedChanges = areObjectsEqual(copyData, form);

  useEffect(() => {
    setForm(formData);
    setCopyData(formData);
  }, [formData]);

  /**
   * Handle color input changes
   */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  /**
   * Validate form
   */
  const validateForm = () => {
    const newErrors = {
      sponsor_color: !form.sponsor_color,
      beneficiary_color: !form.beneficiary_color,
      artist_color: !form.artist_color,
    };
    setErrors(newErrors);
    return !Object.values(newErrors).some((error) => error);
  };

  /**
   * Handle form submission
   */
  const handleClick = () => {
    if (validateForm()) {
      handleSubmit(form);
      setCopyData(form);
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-sm-4 mt-3">
          <label htmlFor="sponsor_color" className="text-gray form-labels">
            Sponsor: {form.sponsor_name && form.sponsor_name}
          </label>
          <div className="row">
            <div className="input-container">
              <input
                type="color"
                name="sponsor_color"
                id="sponsor_color"
                value={form.sponsor_color}
                placeholder=""
                onChange={handleChange}
                className="form-control mt-2 color-picker inputs"
              />
            </div>
            {errors.sponsor_color && (
              <span className="form-text text-danger">
                Sponsor color is required
              </span>
            )}
          </div>
        </div>

        <div className="col-sm-4 mt-3">
          <label htmlFor="beneficiary_color" className="text-gray form-labels">
            Beneficiary: {form.beneficiary_name && form.beneficiary_name}
          </label>
          <div className="row">
            <div className="input-container">
              <input
                type="color"
                name="beneficiary_color"
                id="beneficiary_color"
                value={form.beneficiary_color}
                placeholder=""
                onChange={handleChange}
                className="form-control mt-2 color-picker inputs"
              />
            </div>
            {errors.beneficiary_color && (
              <span className="form-text text-danger">
                Beneficiary color is required
              </span>
            )}
          </div>
        </div>

        <div className="col-sm-4 mt-3">
          <label htmlFor="artist_color" className="text-gray form-labels">
            Artist: {form.artist_name && form.artist_name}
          </label>
          <div className="row">
            <div className="input-container">
              <input
                type="color"
                name="artist_color"
                id="artist_color"
                value={form.artist_color}
                placeholder=""
                onChange={handleChange}
                className="form-control mt-2 color-picker inputs"
              />
            </div>
            {errors.artist_color && (
              <span className="form-text text-danger">
                Artist color is required
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="pt-5">
        <button
          type="button"
          onClick={handleClick}
          className="btn bg-orange form-btn"
          disabled={hasUnsavedChanges}
        >
          Save Changes
        </button>
      </div>
    </>
  );
};

export default Form;
